export const emptyRowPeopleCount = {
  date: null,
  screen: {
    id: null,
    name: '',
  },
  customer: {
    id: null,
    name: '',
  },
  channel: {
    id: null,
    name: '',
  },
  placement: '',
  visitors: '',
  distinctTargetGroups: [],
  hourlyCalculated: null,
};

export const emptyRowExposures = {
  bookingType: null,
  bookingNumber: null,
  bookingName: null,
  mediaFile: {
    id: null,
    name: '',
  },
  fileType: null,
  totalExposures: null,
  primaryExposures: null,
  secondaryExposures: null,
  shareOfVoice: null,
  reach: null,
  date: null,
  customer: {
    id: null,
    name: '',
  },
  screen: {
    id: null,
    name: '',
  },
  channel: {
    id: null,
    name: '',
  },
  placement: null,
  distinctTargetGroups: [],
};

export const targetGroupTableHeaders = [
  'targetGroup1',
  'targetGroup2',
  'targetGroup3',
  'targetGroup4',
  'targetGroup5',
  'targetGroup6',
  'targetGroup7',
  'targetGroup8',
  'targetGroup9',
  'targetGroup10',
  'targetGroup11',
  'targetGroup12',
  'targetGroup13',
  'targetGroup14',
];

export const distinctVehiclesTableHeaders = [
  'cars',
  'vans',
  'buses',
  'trucks'
];

export const FILTER_MAPPING = {
  'targetGroup1': 'TargetGroupW_Under18',
  'targetGroup2': 'TargetGroupW18_24',
  'targetGroup3': 'TargetGroupW25_34',
  'targetGroup4': 'TargetGroupW35_44',
  'targetGroup5': 'TargetGroupW45_54',
  'targetGroup6': 'TargetGroupW55_64',
  'targetGroup7': 'TargetGroupW65_Above',
  'targetGroup8': 'TargetGroupM_Under18',
  'targetGroup9': 'TargetGroupM18_24',
  'targetGroup10': 'TargetGroupM25_34',
  'targetGroup11': 'TargetGroupM35_44',
  'targetGroup12': 'TargetGroupM45_54',
  'targetGroup13': 'TargetGroupM55_64',
  'targetGroup14': 'TargetGroupM65_Above',
  'visitors': 'Total',
  '00:00 - 01:00': 'Hour_0',
  '01:00 - 02:00': 'Hour_1',
  '02:00 - 03:00': 'Hour_2',
  '03:00 - 04:00': 'Hour_3',
  '04:00 - 05:00': 'Hour_4',
  '05:00 - 06:00': 'Hour_5',
  '06:00 - 07:00': 'Hour_6',
  '07:00 - 08:00': 'Hour_7',
  '08:00 - 09:00': 'Hour_8',
  '09:00 - 10:00': 'Hour_9',
  '10:00 - 11:00': 'Hour_10',
  '11:00 - 12:00': 'Hour_11',
  '12:00 - 13:00': 'Hour_12',
  '13:00 - 14:00': 'Hour_13',
  '14:00 - 15:00': 'Hour_14',
  '15:00 - 16:00': 'Hour_15',
  '16:00 - 17:00': 'Hour_16',
  '17:00 - 18:00': 'Hour_17',
  '18:00 - 19:00': 'Hour_18',
  '19:00 - 20:00': 'Hour_19',
  '20:00 - 21:00': 'Hour_20',
  '21:00 - 22:00': 'Hour_21',
  '22:00 - 23:00': 'Hour_22',
  '23:00 - 00:00': 'Hour_23',
  'client': 'clientName',
  'mediaFileName': 'mediaFile',
  'totalExposures': 'totalExposures',
  'cars': 'carsCount',
  'buses': 'busesCount',
  'trucks': 'trucksCount',
  'vans': 'vansCount',
  'opportunityToSee': 'OpportunityToSee',
  'opportunityToSeeVehicles': 'OpportunityToSeeVehicles',
  'vehicles': 'totalVehicles'
};

export const COLUMN_LABELS = {
  date: 'reports.table.date',
  customerName: 'reports.table.customer',
  screenName: 'reports.table.screen',
  channelName: 'reports.table.channel',
  placement: 'reports.table.placement',
  screenType: 'reports.table.tracking',
  visitors: 'reports.table.visitors',
  menAverageTimeInChannel: 'reports.table.avgTimeInChannelMan',
  womenAverageTimeInChannel: 'reports.table.avgTimeInChannelWomen',
  bookingType: 'reports.table.bookingType',
  bookingNumber: 'reports.table.bookingNumber',
  bookingName: 'reports.table.bookingName',
  fileType: 'reports.table.fileType',
  client: 'reports.table.client',
  mediaFileName: 'reports.table.mediaFile',
  totalExposures: 'reports.table.totalExposures',
  primaryExposures: 'reports.table.primaryExposures',
  secondaryExposures: 'reports.table.secondaryExposures',
  shareOfVoice: 'reports.table.shareOfVoice',
  airtime: 'reports.table.airTime',
  attentionTime: 'reports.table.attentionTime',
  impression: 'reports.table.impressions',
  reach: 'reports.table.reach',
  opportunityToSee: 'reports.table.opportunityToSee',
  category: 'poi.table.poiCategoryName',
  personOfInterest: 'poi.table.poiName',
  poiCreatedDate: 'poi.table.poiCreated',
  createdBy: 'poi.table.poiCreatedBy',
  smsSentTo: 'poi.table.notificationSentTo',
  cars: 'reach.vehicles.cars',
  vans: 'reach.vehicles.vans',
  buses: 'reach.vehicles.buses',
  trucks: 'reach.vehicles.trucks',
  opportunityToSeeVehicles: 'reports.table.opportunityToSee',
  vehicles: 'reach.vehicles.title',
  price: 'reports.table.price',
  currency: 'reports.table.currency',
  pricingModel: 'reports.table.pricingModel',
  budgetedImpressions: 'reports.table.budgetedImpressions',
  cppCampaignBudget: 'reports.table.cppCampaignBudget',
  totalCPP: 'reports.table.totalCpp',
  impressionsOutcome: 'reports.table.impressionsOutcome',
  cppOutcome: 'reports.table.cppOutcome',
  budgetedExposures: 'reports.table.budgetedExposures',
  cpvCampaignBudget: 'reports.table.cpvCampaignBudget',
  totalCPV: 'reports.table.totalCpv',
  exposuresOutcomes: 'reports.table.exposuresOutcome',
  cpvOutcomes: 'reports.table.cpvOutcome',
};


